import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import c from "./index289.js";
const l = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(s, o, m, p, v, i) {
  return e(), t("svg", n, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M9.845 3.07a3 3 0 0 1 4.125.002l5.327 5.035a4.017 4.017 0 0 1 1.253 2.917v7.755a2.325 2.325 0 0 1-2.32 2.331H5.57a2.326 2.326 0 0 1-2.32-2.331v-7.753c0-1.106.455-2.163 1.258-2.92Zm3.095 1.092a1.5 1.5 0 0 0-2.065 0L5.537 9.196a2.515 2.515 0 0 0-.787 1.829v7.753c0 .46.369.831.82.831l3.111-.001v-4.937c0-.87.703-1.577 1.571-1.577h3.296c.868 0 1.57.707 1.57 1.577v4.937l3.112.001a.824.824 0 0 0 .814-.727l.006-.104v-7.755c0-.692-.284-1.354-.784-1.827Zm.608 10.433h-3.296c-.038 0-.07.033-.07.077l-.001 4.937h3.437v-4.937c0-.044-.032-.077-.07-.077Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ c(l, [["render", a]]);
export {
  d as default
};
